"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionDialog = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const form_text_field_1 = require("../../composite/form/fields/form-text-field");
function CollectionDialog() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_text_field_1.FormTextField, { name: "name", label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION__FIELD_LABEL__NAME", defaultMessage: "N\u00E1zev" }), autoFocus: true })));
}
exports.CollectionDialog = CollectionDialog;
//# sourceMappingURL=collection-dialog.js.map